export default __webpack_public_path__ + "static/media/upChevron.20ef6c22.svg";